export const UPLOAD_PHOTO = {
  init: 'reviews/UPLOAD_PHOTO/init',
  request: 'reviews/UPLOAD_PHOTO/request',
  delete: 'reviews/UPLOAD_PHOTO/delete',
  success: 'reviews/UPLOAD_PHOTO/success',
  failure: 'reviews/UPLOAD_PHOTO/failure',
} as const;
